import {useQuery} from "@tanstack/react-query";

import {useAuthUserId} from "../../../selectors/AuthSelectors";
import {useRestaurantId} from "../../../selectors/RestaurantSelectors";
import {getGuestmeGatewayStatusRequest} from "../../../api";


export function useGatewayStatusQueryKey() {
  return [useAuthUserId(), "gateway_status", useRestaurantId()];
}

export function useGatewayStatus(refetchInterval: number = 1000 * 60 * 5) {
  const restaurantId = useRestaurantId();

  const { data: response, isLoading, isFetching, isFetched } = useQuery({
    staleTime: 0,
    refetchInterval,
    queryKey: useGatewayStatusQueryKey(),
    queryFn: () => getGuestmeGatewayStatusRequest(restaurantId),
    enabled: !!restaurantId,
  });

  return {
    isFetched,
    isLoading: isLoading || isFetching,
    data: (response && response.data) ? response.data : null,
  };
}
